<template>
	<div ref="ParticipantDetail" class="dialog-container">
		<div class="dialog scroll" style="transform: translate(0, -400px); max-width: 960px;">
			<form @submit.stop="doValidation()">
				<div class="home-title">
					<div class="title-left" style="font-size: 20px;">
						<img style="width: 31px; height: 16px;" src="@/assets/images/login/participant_icon.png" />
						<span>참여자 상세정보</span>
					</div>
				</div>
				<div class="participant-tab-zone">
					<div class="participant-btn" :class="isTab === 1 ? 'participant-on' : ''" @click.stop="changeTap(1)">
						참여자 정보
					</div>
					<div class="participant-btn" :class="isTab === 2 ? 'participant-on' : ''" @click.stop="changeTap(2)">
						알림 내역
					</div>
					<div class="participant-btn" :class="isTab === 3 ? 'participant-on' : ''" @click.stop="changeTap(3)">
						응급조치 내역
					</div>
				</div>
				<ParticipantInfo v-if="isTab === 1" :collectData="collectData"/>
				<ParticipantNotice v-if="isTab === 2" :collectData="collectData"/>
				<ParticipantEmergency v-if="isTab === 3" :collectData="collectData"/>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";
import ParticipantInfo from "@/components/participant/ParticipantInfo.vue";
import ParticipantNotice from "@/components/participant/ParticipantNotice.vue";
import ParticipantEmergency from "@/components/participant/ParticipantEmergency.vue";

export default {
	name: "ParticipantDetail",
	created() {
		this.logger.debug(this, "created()");
		this.firstRegistDate = moment().format("YYYY-MM-DD");
		this.firstRegistUserId = this.userInfo.userId;
		this.firstRegistUserName = this.userInfo.userName;
	},
	props: {
		collectData: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			item: {},
			isTab: 1,
		};
	},
	components:{
		ParticipantInfo,
		ParticipantNotice,
		ParticipantEmergency,
	},
	methods: {
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to register the current Question Group?", "Question", "question").then(() => {
							EventBus.$emit("field-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		selectSortOrder() {
			this.logger.debug(this, "selectSortOrder()");

			axios
				.post(this.config.contextRoot + "/field/selectSortOrder.do", this.item)
				.then((response) => {
					console.log(response);

					this.item = response.data.item;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				})
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");
			axios
				.post(this.config.contextRoot + "/field/insertGroup.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("Complete", "Success", "success").then(() => {
							// location.reload();
							this.$parent.selectProjectList();
							this.$parent.selectQuestionGroupList();
							this.doClose();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("취소하시겠습니까?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.ParticipantDetail.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.ParticipantDetail.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("project-cancel", "isDataPopup");
			}.bind(this), 410);
		},
		changeTap(type){
			this.isTab = type;
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
.popup-table th{
	background-color: #F8F9FB;
}
.popup-table tr:first-child > th{
	border-top: 1px solid #191C26
}
.popup-table tr:first-child > td{
	border-top: 1px solid #191C26
}
.dialog-tag{
	font-size: 18px;
	font-weight: bold;
}
.dialog-flex{
	display: flex;
    column-gap: 40px;
    justify-content: space-between;
	margin: 
}
.dialog-flex > div{
	width: 100%;
}
.popup-table td{
	border-left: 1px solid #ddd;
	border-right: 1px solid #ddd;
}
.popup-table td:last-child{
	border-right: none;
}
.participant-tab-zone{
	width: 100%;
	height: 48px;
	margin-top: 20px;
	background-color: #EBF4FF;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 0 5px;
	column-gap: 5px;
}
.participant-btn{
	height: 40px;
	border-radius: 6px;
	display: flex;
    justify-content: center;
    align-items: center;
	flex: 1;
	color: #090909;
	font-size: 18px;
	cursor: pointer;
}
.participant-btn:hover{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.participant-on{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.font-red{
	color: #F94848;
}
.font-yellow{
	color: #FFAD09;
}
</style>